export default {
  name: 'auth--authority',
  apiService: 'auth',
  apiPath: '/authority',
};